import { Gender } from '@dokucoach/common-types';
import DiverseSvg from 'assets/menu-list-icon/diverse.svg';
import FemaleSvg from 'assets/menu-list-icon/female.svg';
import MaleSvg from 'assets/menu-list-icon/male.svg';
import DiverseOldSvg from 'assets/menu-list-icon/diverse-old.svg';
import FemaleOldSvg from 'assets/menu-list-icon/female-old.svg';
import MaleOldSvg from 'assets/menu-list-icon/male-old.svg';

export enum AvatarImageType {
  DEFAULT = 'DEFAULT',
  OLD = 'OLD',
}

export const getAvatarImage = (
  gender: Gender,
  type: AvatarImageType = AvatarImageType.DEFAULT,
): string => {
  switch (gender) {
    case Gender.FEMALE:
      if (type === AvatarImageType.OLD) {
        return FemaleOldSvg;
      }
      return FemaleSvg;
    case Gender.MALE:
      if (type === AvatarImageType.OLD) {
        return MaleOldSvg;
      }
      return MaleSvg;
    default:
      if (type === AvatarImageType.OLD) {
        return DiverseOldSvg;
      }
      return DiverseSvg;
  }
};
